module.exports = __webpack_public_path__ + "static/media/mission.7c17782d.png";